import { Box, styled } from '@mui/material';
import HeroBannerDesktop from '../../assets/images/onboard/onboard-hero-banner-desktop.png';
import HeroBannerMobile from '../../assets/images/onboard/onboard-hero-banner-mobile.png';
import HeroBannerTablet from '../../assets/images/onboard/onboard-hero-banner-tablet.png';

const Picture = styled(Box)`
  display: block;
  width: 100%;
  aspect-ratio: 1688 / 250; /* desktop image aspect ratio */
  margin-bottom: 2.5rem;
` as typeof Box;

function HeroBanner() {
  return (
    <Picture component="picture">
      <source media="(max-width:600px)" srcSet={HeroBannerMobile} />
      <source media="(max-width:1200px)" srcSet={HeroBannerTablet} />
      <img
        src={HeroBannerDesktop}
        alt=""
        style={{
          width: '100%',
          height: 'auto',
          display: 'block',
        }}
      />
    </Picture>
  );
}

export default HeroBanner;
